import styled, { css } from 'styled-components'
type PProps = {
   color?: string
   fontSize?: string
   center?: boolean
   bold?: boolean
   italic?: boolean
   black?: boolean
   background?: string
   marginBottom?: string
   fontWeight?: string
   secondColor?: string
   secondWeight?: string
   secondSize?: string
   uppercase?: boolean
   margin?: string
   helveticaLight?: boolean
   helveticaExt?: boolean
   dot?: boolean
   justify?: boolean
   left?: string
   top?: string
   width?: string
   height?: string
}
const P: any = styled.p`
   font-size: 18px;
   font-family: 'Arial';
   text-align: left;
   z-index: 10;
   ${(props: PProps) =>
      props.color &&
      css`
         color: ${props.color};
      `}
   ${(props: PProps) =>
      props.fontSize &&
      css`
         font-size: ${props.fontSize};
      `}
    ${(props: PProps) =>
      props.center &&
      css`
         text-align: center;
      `}
    ${(props: PProps) =>
      props.bold &&
      css`
         font-weight: bold;
      `}
    ${(props: PProps) =>
      props.italic &&
      css`
         font-style: italic;
      `}
    ${(props: PProps) =>
      props.black &&
      css`
         font-weight: 800;
      `}
    ${(props: PProps) =>
      props.background &&
      css`
         background-color: ${props.background};
      `}
    ${(props: PProps) =>
      props.marginBottom &&
      css`
         margin-bottom: ${props.marginBottom};
      `}
    ${(props: PProps) =>
      props.fontWeight &&
      css`
         font-weight: ${props.fontWeight};
      `}
    span {
      ${(props: PProps) =>
         props.secondColor &&
         css`
            color: ${props.secondColor};
         `}
      ${(props: PProps) =>
         props.secondWeight &&
         css`
            font-weight: ${props.secondWeight};
         `}
        ${(props: PProps) =>
         props.secondSize &&
         css`
            font-size: ${props.secondSize};
         `}
   }
`
const PThin: any = styled.p`
    font-size : 18px;
    font-family: "Helvetica Neue Std";
    text-align : left;
    ${(props: PProps) =>
       props.color &&
       css`
          color: ${props.color};
       `}
    ${(props: PProps) =>
       props.fontSize &&
       css`
          font-size: ${props.fontSize};
       `}
    ${(props: PProps) =>
       props.background &&
       css`
          background-color: ${props.background};
       `}
    ${(props: PProps) =>
       props.center &&
       css`
          text-align: center;
       `}
    span{
        ${(props: PProps) =>
           props.secondColor &&
           css`
              color: ${props.secondColor};
           `}
`
const PExt: any = styled.p`
   font-size: 18px;
   font-family: 'Helvetica Neue Extended';
   text-align: left;
   ${(props: PProps) =>
      props.color &&
      css`
         color: ${props.color};
      `}
   ${(props: PProps) =>
      props.helveticaLight &&
      css`
         font-family: 'Helvetica Neue LightExt';
      `}
    ${(props: PProps) =>
      props.fontSize &&
      css`
         font-size: ${props.fontSize};
      `}
    ${(props: PProps) =>
      props.background &&
      css`
         background-color: ${props.background};
      `}
    ${(props: PProps) =>
      props.center &&
      css`
         text-align: center;
      `}
    ${(props: PProps) =>
      props.justify &&
      css`
         text-align: justify;
      `}
    ${(props: PProps) =>
      props.margin &&
      css`
         margin: ${props.margin};
      `}
    ${(props: PProps) =>
      props.black &&
      css`
         font-family: 'Helvetica Neue Boldext';
      `}
    ${(props: PProps) =>
      props.uppercase &&
      css`
         text-transform: uppercase;
      `}
    span {
      ${(props: PProps) =>
         props.secondColor &&
         css`
            color: ${props.secondColor};
         `}
      ${(props: PProps) =>
         props.secondWeight &&
         css`
            font-family: 'Helvetica Neue Boldext';
         `}
        ${(props: PProps) =>
         props.secondSize &&
         css`
            font-size: ${props.secondSize};
         `}
   }
`
const PBoldExt: any = styled.p`
   font-size: 15px;
   font-family: 'Helvetica Neue Boldext';
   text-align: left;
   margin: 10px 0;

   ${(props: PProps) =>
      props.color &&
      css`
         color: ${props.color};
      `}
   ${(props: PProps) =>
      props.fontSize &&
      css`
         font-size: ${props.fontSize};
      `}
    ${(props: PProps) =>
      props.center &&
      css`
         text-align: center;
      `}
    ${(props: PProps) =>
      props.uppercase &&
      css`
         text-transform: uppercase;
      `}
    ${(props: PProps) =>
      props.margin &&
      css`
         margin: ${props.margin};
      `}
    ${(props: PProps) =>
      props.background &&
      css`
         background-color: ${props.background};
      `}
    span {
      ${(props: PProps) =>
         props.secondColor &&
         css`
            color: ${props.secondColor};
         `}
   }
`
const Li: any = styled.li`
   font-size: 28px;
   font-family: 'Arial';
   text-align: left;
   margin: 7px 0 7px 23px;
   text-indent: -23px;
   ${(props: PProps) =>
      props.helveticaLight &&
      css`
         font-family: 'Helvetica Neue LightExt';
      `}
   ${(props: PProps) =>
      props.helveticaExt &&
      css`
         font-family: 'Helvetica Neue Extended';
      `}
    ${(props: PProps) =>
      props.color &&
      css`
         color: ${props.color};
      `}
    ${(props: PProps) =>
      props.fontSize &&
      css`
         font-size: ${props.fontSize};
      `}
    ${(props: PProps) =>
      props.center &&
      css`
         text-align: center;
      `}
    ${(props: PProps) =>
      props.background &&
      css`
         background-color: ${props.background};
      `}
    b {
      font-weight: 800;
   }
   span {
      ${(props: PProps) =>
         props.secondColor &&
         css`
            color: ${props.secondColor};
         `}
      ${(props: PProps) =>
         props.secondWeight &&
         css`
            font-weight: ${props.secondWeight};
         `}
   }
   ${(props: PProps) =>
      props.dot &&
      css`
         :before {
            content: '•';
            margin-right: 10px;
         }
      `}
`
const Li2: any = styled.li`
   font-size: 28px;
   font-family: 'Arial';
   text-align: left;
   margin: 2px 0 2px 23px;
   text-indent: -23px;
   ${(props: PProps) =>
      props.helveticaLight &&
      css`
         font-family: 'Helvetica Neue LightExt';
      `}
   ${(props: PProps) =>
      props.helveticaExt &&
      css`
         font-family: 'Helvetica Neue Extended';
      `}
    ${(props: PProps) =>
      props.color &&
      css`
         color: ${props.color};
      `}
    ${(props: PProps) =>
      props.fontSize &&
      css`
         font-size: ${props.fontSize};
      `}
    ${(props: PProps) =>
      props.center &&
      css`
         text-align: center;
      `}
    ${(props: PProps) =>
      props.background &&
      css`
         background-color: ${props.background};
      `}
    b {
      font-weight: 800;
   }
   span {
      ${(props: PProps) =>
         props.secondColor &&
         css`
            color: ${props.secondColor};
         `}
      ${(props: PProps) =>
         props.secondWeight &&
         css`
            font-weight: ${props.secondWeight};
         `}
   }
   ${(props: PProps) =>
      props.dot &&
      css`
         :before {
            content: '•';
            margin-right: 10px;
         }
      `}
`
const BackTxt: any = styled.div`
   position: absolute;
   height: 25px;
   z-index: 0;
   ${(props: PProps) =>
      props.color &&
      css`
         background: ${props.color};
      `}
   ${(props: PProps) =>
      props.top &&
      css`
         top: ${props.top}px;
      `}
    ${(props: PProps) =>
      props.left &&
      css`
         left: ${props.left}px;
      `}
    ${(props: PProps) =>
      props.width &&
      css`
         width: ${props.width}px;
      `}
    ${(props: PProps) =>
      props.height &&
      css`
         height: ${props.height}px;
      `}
`
export { BackTxt, Li, Li2, P, PBoldExt, PExt, PThin }
